import { withAuthenticationRequired } from "@auth0/auth0-react";
import React from "react";

export const ProtectedRoute = ({ component }) => {
  const Component = withAuthenticationRequired(component, {
    onRedirecting: () => (
      <div className="pos-center">
        <div className="loader"></div>
      </div>
    ),
  });

  return(
    <div>
      <Component />
    </div>
  )
};